'use strict';

var Field = require('./Field');

angular.module('dekky.forms.fields.selectObject', [])
	.factory('SelectObjectField', function() {
		function selectObjectFactory(name, options, items) {
			function SelectObject(name, options, items) {
				if (!Array.isArray(items)) {
					throw new Error('Not items for select');
				}
				if (options.ngOptions === undefined) {
					throw new Error('Not defined ngOptions');
				}

				this.name = name;
				this.type = 'selectObject';
				this.items = items;
				this.ngOptions = options.ngOptions;

				Field.apply(this, arguments);
			}

			SelectObject.prototype = Object.create(Field.prototype);

			return new SelectObject(name, options, items);
		}

		return selectObjectFactory;
	});